import React, { useContext } from "react";
import { Card, CardBody, CardTitle, CardText } from "reactstrap";
import { StateContext } from "../utils/context";

const REACT_APP_PLATFORM_URL = process.env.REACT_APP_PLATFORM_URL;

const UserWelcome = () => {
  const { currentUser } = useContext(StateContext);
  const displayFirstName = currentUser.firstname || currentUser.first_name || "";

  return (
    <Card>
      <CardBody>
        {Object.keys(currentUser).length > 0 && (
          <>
            {
              !currentUser.is_subscribed && <CardTitle>Hey {displayFirstName}, Welcome to <b>Move Music DEMO dashboard</b>. Feel free to browse around our dashboard and if you wish to become Move Music user, please choose a package below. </CardTitle>
            }
            {
              currentUser.is_subscribed &&
              <CardTitle>
                Dear {displayFirstName}, your demo account period has come to an end. However, we see that you've already fully subscribed to our services.
                <br/><br/>
                <p style={{color: "#b40bbe"}}>
                  Please check your email for further instructions and log in into <a href={REACT_APP_PLATFORM_URL}>{REACT_APP_PLATFORM_URL}</a> to use our services.
                  <br/>
                  Do not forget to save this URL into your bookmarks.
                  <br/>
                </p>
                If you run into any issues or have questions, feel free to reach out to our support team.
              </CardTitle>
            }
          </>
        )}
      </CardBody>
    </Card>
  );
};

export default UserWelcome;
